import React, { useCallback, useMemo } from "react";

import { HubHookFormSelect } from "../HubHookFormSelect";
import { useMaterialListWithCache } from "./useMaterialListWithCache";
import { filterMaterialsHelper, filterFnc } from "./helper";
import { HubHookFormSelectV2 } from "../HubHookFormSelectV2";

const defaultList = { tress: [], materials: [] };
const groupKey = {
  materials: "category",
  trees: "location.name",
};

export const HubMaterialHookSelect = ({
  type = "materials",
  name = "material",
  label = "Material",
  previousItems = [],
  defaultValue,
  hideLabel = false,
  dispatch = () => {},
  disabled = false,
  departmentId,
  customFilter,
  showOnlyGroup,
  defaultOpenGroup,
  required = true,
  enableSearch = false,
  ...rest
}) => {
  const { materials, isLoading } = useMaterialListWithCache();
  const options = materials || defaultList;

  // Filter Material By Type & Rules
  const filterPayload = { type, previousItems, options, showOnlyGroup };
  const filter = () => filterMaterialsHelper(filterPayload);
  const dependency = [type, options, showOnlyGroup, required, previousItems];
  const list = useMemo(filter, dependency);

  const defaultInput = defaultValue || list[0]?.id;
  const key = groupKey[type] || groupKey.trees;

  // Filter Material by department or other
  const cFilter = filterFnc({ customFilter, departmentId });
  const customFilterDep = [customFilter, departmentId];
  const filterFunction = useCallback(cFilter, customFilterDep);

  // Determine Filter
  const useFilter = customFilter || departmentId;
  const filtered = useFilter ? list.filter(filterFunction) : list;

  const props = {
    name,
    required,
    defaultValue: defaultInput,
    disabled: isLoading || disabled,
    options: filtered,
    allowNull: !required,
    noOptionsText: "No Materials Found",
    ...(!hideLabel ? { label } : {}),
    ...rest,
  };
  return enableSearch ? (
    <HubHookFormSelectV2 {...props} />
  ) : (
    <HubHookFormSelect
      groupByKey={!showOnlyGroup && key}
      defaultOpenGroup={defaultOpenGroup}
      {...props}
    />
  );
};
